import { useRouter } from 'next/router'
import Image from 'next/legacy/image'
// Components
import Button from '../newButton/Button'
import styles from './Hero.module.scss'

export default function Hero ({ query, setQuery }) {
  const router = useRouter()
  return (
    <div className={styles.background}>
      <div className={styles.hero}>
        <div className={styles.content}>
          <h1>The Daily Dog</h1>

          <h2>
            Happy pup, happy life! Find answers to all your pet questions below.
          </h2>

          <form className={styles.search} onSubmit={(e) => e.preventDefault()}>
            <Button
              theme={['extra-short', 'green-solid']}
              centerImage='/search/search.svg'
              altImg='White magnifying glass icon'
              onClick={() => router.push(`/blog?search=${query}`)}
            />

            <input
              type='text'
              placeholder='Why does my dog bite?'
              autoComplete='off'
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </form>
        </div>
        <div className={styles.image}>
          {/* eslint-disable */}
          <Image
            width={700}
            height={390}
            src='/woof-paper.png'
            alt="Black Labrador Retriever reading a newspaper titled Daily Dog"
            objectFit='contain' 
            layout='responsive'
          />
          {/* eslint-disable */}
        </div>
      </div>
    </div>
  )
}
